import { useQuery, useLazyQuery } from '@apollo/client';
import { getCustomer } from '../queries/customer.graphql';
import { customerClientCallback } from '../helpers/customer';

export const useCustomer = (customerId, token) => {
  const { loading, data, error, called } = useQuery(getCustomer, {
    variables: {
      customerId,
      token,
    },
    skip: !customerId || !token,
    ssr: false,
  });

  return { loading, data, error, called };
};

export const useLazyCustomer = (customerId, token, callbackCompleted, callbackError) => {
  const [fetchCustomer, { data }] = useLazyQuery(getCustomer, {
    variables: { customerId, token },
    skip: !customerId || !token,
    ssr: false,
    fetchPolicy: 'network-only',
    onCompleted: customerClientCallback(callbackCompleted),
    onError: customerClientCallback(callbackError),
  });

  return { fetchCustomer, data };
};
